export let LayerType;(function(e){e["BASE"]="BASE";e["STATIC"]="STATIC";e["DYNAMIC"]="DYNAMIC"})(LayerType||(LayerType={}));